import React, { useState, useRef } from 'react';
import '../styles/VoiceGenerator.css';
import { FaMicrophone, FaPlay, FaPause, FaSpinner, FaDownload } from 'react-icons/fa';

const API_KEY = 'CdWxiwLHaHIF69BgdJnvmhI2JwMMeXCYBi4Kr0TEFxyHw5J5bNbTX6lzl0yD';
const API_URL = 'https://modelslab.com/api/v6/voice/text_to_audio';

const VoiceGenerator = () => {
  const [text, setText] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [audioUrl, setAudioUrl] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);

  const generateVoice = async () => {
    if (!text.trim()) {
      setError('Please enter some text');
      return;
    }

    setLoading(true);
    setError('');
    setAudioUrl(null);

    try {
      const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          key: API_KEY,
          prompt: text.trim(),
          language: 'english',
          init_audio: 'https://pub-f3505056e06f40d6990886c8e14102b2.r2.dev/audio/tom_hanks_1.wav'
        })
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || `API Error: ${response.status}`);
      }

      const data = await response.json();
      console.log('Voice Generation Response:', data);

      if (data.status === 'success' && data.output && data.output[0]) {
        setAudioUrl(data.output[0]);
      } else {
        throw new Error('Invalid response from server');
      }
    } catch (err) {
      console.error('Voice Generation Error:', err);
      setError(err.message || 'Failed to generate voice');
    } finally {
      setLoading(false);
    }
  };

  const togglePlay = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleAudioEnded = () => {
    setIsPlaying(false);
  };

  return (
    <div className="voice-generator">
      <div className="generator-header">
        <FaMicrophone className="header-icon" />
        <h2>AI Voice Generator</h2>
        <p>Transform text into natural-sounding speech</p>
      </div>

      <div className="generator-content">
        <div className="input-section">
          <textarea
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder="Enter text to convert to speech..."
            disabled={loading}
          />

          <button 
            onClick={generateVoice}
            disabled={loading || !text.trim()}
            className="generate-button"
          >
            {loading ? (
              <>
                <FaSpinner className="spinner" />
                Generating...
              </>
            ) : 'Generate Voice'}
          </button>
        </div>

        {error && (
          <div className="error-message">
            {error}
          </div>
        )}

        {audioUrl && (
          <div className="audio-result">
            <audio 
              ref={audioRef}
              src={audioUrl}
              onEnded={handleAudioEnded}
              onPause={() => setIsPlaying(false)}
              onPlay={() => setIsPlaying(true)}
            />
            
            <div className="audio-controls">
              <button 
                onClick={togglePlay}
                className="play-button"
              >
                {isPlaying ? <FaPause /> : <FaPlay />}
                <span>{isPlaying ? 'Pause' : 'Play'}</span>
              </button>

              <a 
                href={audioUrl}
                download="ai-generated-voice.wav"
                className="download-button"
              >
                <FaDownload />
                <span>Download</span>
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default VoiceGenerator; 